// Locale Intl + interpolation pour les notifications (cloche + toast).
// localeFor(lang) → BCP-47 pour Date#toLocaleString ; format(str, params) → {x} → valeur.

export const INTL_LOCALE: Record<string, string> = {
  en: 'en-US', fr: 'fr-FR', pt: 'pt-PT', de: 'de-DE', nl: 'nl-NL', it: 'it-IT', es: 'es-ES',
  ka: 'ka-GE', ru: 'ru-RU', zh: 'zh-CN', ja: 'ja-JP', he: 'he-IL', ar: 'ar',
};

/** Langue UI → locale BCP-47 (fallback en-US). Insensible à la casse. */
export const localeFor = (lang?: string | null): string =>
  INTL_LOCALE[(lang || 'en').toLowerCase()] ?? 'en-US';

/**
 * Remplace les placeholders {x} par params[x]. Si un placeholder n'a pas de
 * valeur, il est laissé tel quel — le renderer s'en sert pour détecter un
 * param manquant et retomber sur le message stocké (régression 0).
 */
export function format(str: string, params: Record<string, string | number> = {}): string {
  return str.replace(/\{(\w+)\}/g, (m, key) => (key in params ? String(params[key]) : m));
}
